import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCelebrations } from "src/services/CelebrationsService"; 
import  CelebrationItemList  from "src/content/dashboards/Cards/components/CelebrationItemList"; 
import  TodayCelebrationsItems  from "src/content/dashboards/Cards/components/TodayCelebrationsItems"; 

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import {
  getDaysUntil,
  CelebrationInformation,
} from 'src/utils/celebrationUtils'; 
import CloseIcon from '@mui/icons-material/Close';

import CelebrationIcon from '@mui/icons-material/Celebration';  
import '../NewDashboard.css';

const CelebrationsWidget = () => {

  const [weeklyData, setweeklyData] = useState<CelebrationInformation[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [monthlyData, setMonthlyData] = useState<CelebrationInformation[]>([]);

  const now = new Date();
  const daysOfWeek = now.getDay();

  const formatDate = (date: Date): string => {
    return date.toISOString().split('T')[0];
  };

  useEffect(() => {
    const fetchCelebrations = async () => {
      try {
        const startDate = new Date(now);
        startDate.setDate(now.getDate() - daysOfWeek +1)

        const endDate  = new Date(now);
        endDate.setDate(now.getDate() +(6 - daysOfWeek +1))

        const response = await getCelebrations(formatDate(startDate),formatDate(endDate)); 
        const weeklyData = response?.data?.data?.birthdayAndMilestones;
        
        if (Array.isArray(weeklyData) && weeklyData.length > 0) {
          setweeklyData(weeklyData);
        }
      } catch (error) {
        toast.error("Failed to fetch Celebrations Data. Please try again later.");
      }
    };    
    
    fetchCelebrations();
  }, []);

  const handleShowMore = async () => {
    try {

      const startDate = new Date(now);
      startDate.setDate(now.getDate() - daysOfWeek -7 )

      const endDate  = new Date(now);
      endDate.setDate(now.getDate() +(6 - daysOfWeek)+7)

      const response = await getCelebrations(formatDate(startDate), formatDate(endDate));
      const monthlyData = response?.data?.data?.birthdayAndMilestones;

      if (Array.isArray(monthlyData) && monthlyData.length > 0) {
        setMonthlyData(monthlyData);
        setDialogOpen(true);
      }
    } catch (error) {
      toast.error("Failed to fetch Celebrations Data. Please try again later.");
    }
  };


  return (
    <div className="celebrations-widget"
      style={{backgroundImage: `linear-gradient(to bottom, #D1D2FD, #FFFFFF), url(${process.env.PUBLIC_URL}/img/celebrations-banner.png)`,}}
    >
      
      {weeklyData.some(event => {
        const isToday = getDaysUntil(new Date(event.dob)) === 0 || getDaysUntil(new Date(event.joinedDate)) === 0;
        return isToday;
      }) && (
        <>
          <div className="widget-header">
            <CelebrationIcon
              sx={{ alignSelf: 'center', fontSize: '22px', marginRight: '4px' }}
            />
            Today's Celebrations
          </div>

          <div className="today-celebrations-list">
            <TodayCelebrationsItems data={weeklyData}/>
          </div>
        </>
      )}

      <div className="widget-header">
        <CelebrationIcon
          sx={{ alignSelf: 'center', fontSize: '20px', marginRight: '6px' }}
        />
        This Week's Celebrations    
      </div>

      { weeklyData?.length > 0 ? (
        <>
          <div className="celebrations-list">
            <CelebrationItemList data={weeklyData} period="week" />
          </div>

        </>
      ) : (
        <span className="no-celebrations-text">No celebrations this week</span>
      )}

      <div className="show-more">
        <button onClick={handleShowMore}>Show Celebrations →</button>
      </div>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <div className="widget-header">
            <CelebrationIcon
              sx={{ alignSelf: 'center', fontSize: '22px', marginRight: '4px' }}
            />
            Celebrations
          </div>
          <IconButton
            aria-label="close"
            onClick={() => setDialogOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <CelebrationItemList data={monthlyData} period="three-weeks" />
        </DialogContent>
      </Dialog>
  
    </div>

  );
};

export default CelebrationsWidget;